export const locale = {
  lang: "en",
  data: {
    NAV: {
      DASHBOARDS: "Bảng điều khiển",
      LIST: "Danh mục",
      REPORT: "Báo cáo tổng hợp",
      USERS_LIST: {
        USER: "Tài khoản hệ thống"
      },
      LIST_LIST: {
        OTHERLIST: "Danh mục dùng chung"
      }
    },
    NAV_SYSTEM: {
      DASHBOARDS: "Bảng điều khiển",
      USERS: "Hệ thống",
      USERS_LIST: {
        USER: "Tài khoản hệ thống"
      }
    }
  }
};
